/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Profile Icon
 *
 * @file ProfileIcon.jsx
 * @author Gladson Samuel S
 * @since 0.0.1
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import PropType from 'prop-types';

const ProfileIcon = ({ className }) => (
  <SvgIcon className={className} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.4545 10C15.0695 10 18 12.8654 18 16.4V17.2C18 17.6418 17.6337 18 17.1818 18H0.818182C0.366313 18 0 17.6418 0 17.2V16.4C0 12.8654 2.9305 10 6.54545 10H11.4545ZM11.4545 11.6H6.54546C3.89586 11.6 1.73653 13.6525 1.63975 16.2201L1.63636 16.4H16.3636C16.3636 13.8093 14.2645 11.698 11.6386 11.6033L11.4545 11.6ZM9 0C11.4853 0 13.5 1.96995 13.5 4.4C13.5 6.83006 11.4853 8.8 9 8.8C6.51472 8.8 4.5 6.83006 4.5 4.4C4.5 1.96995 6.51472 0 9 0ZM9 1.6C7.41846 1.6 6.13636 2.8536 6.13636 4.4C6.13636 5.9464 7.41846 7.2 9 7.2C10.5815 7.2 11.8636 5.9464 11.8636 4.4C11.8636 2.8536 10.5815 1.6 9 1.6Z" fill="currentColor" />
  </SvgIcon>
);

ProfileIcon.propTypes = {
  className: PropType.string.isRequired
};

export default ProfileIcon;

